import { useStore } from 'effector-react';
import Input from '@components/Input';
import Tip from '@components/Tip';
import useInputHandlers from '@hooks/useInputHandelrs';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import { Collapse } from '@components/Collapse';

export function PartnerIDSetting() {
  const { hotspot } = useStore($editingHotspot)!;
  const handler = useInputHandlers((val) =>
    $editingHotspotApi.update((draft) => {
      draft.partnerId = val;
    })
  );

  return (
    <Collapse
      title={
        <div className="flex">
          第三方平台ID
          <Tip className="ml-5 self-end">非必填</Tip>
        </div>
      }
    >
      <Input
        scheme="dark"
        className="h-40"
        value={hotspot.partnerId ?? ''}
        placeholder="请输入该热点在第三方关联的ID"
        {...handler}
      />
      <Tip className="mt-10 text-orange">
        注：通过关联第3方平台ID在接入SDK二次开发时可以更便捷查询到对应热点
      </Tip>
    </Collapse>
  );
}
